import './styles/hold-item.scss'

import React      from 'react'
import PropTypes  from 'prop-types'
import moment     from 'moment'
import classnames from 'classnames'

function formatTime(timestamp) {
  return moment(timestamp).format('YYYY-MM-DD h:mm:ss A')
}

function getHoldDuration(startTime, endTime) {  
  return `About ${moment.duration(new Date(endTime).getTime() - new Date(startTime).getTime()).humanize()}`
}

export default class HoldItem extends React.Component {
  static propTypes = {
    item:    PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
  }

  renderHighlight = (title, message) => {
    const className = classnames('item-highlight ui mini message')

    return (
      <div className={className}>
        <div className="title">{ title }</div>
        <div className="message">{ message }</div>        
      </div>
    )
  }

  render() {
    const { item } = this.props

    const showTimeRange = item.startTime && item.endTime

    const startTime = formatTime(item.startTime)
    const endTime   = formatTime(item.endTime)    
    const duration  = item.startTime
      && item.endTime
      && getHoldDuration(startTime, endTime)

    return (
      <div className="hold-item">
        <div className="header">
          <div className="name">{ item.name }</div>
          { item.description && <div className="description">{ `(${item.description})` }</div> }
        </div>

        <div className="details">
          { item.sender    && this.renderHighlight('Sender',    item.sender.name )   }
          { item.receiver  && this.renderHighlight('Receiver',  item.receiver.name )   }
          { item.dataType  && this.renderHighlight('Data Type', item.dataType.name ) }

          { showTimeRange && (
            <div className="time-range-container">
              <div className="time-range">
                { this.renderHighlight('Start', startTime ) }
                { duration && (
                  <div className="line">
                    <div>{duration}</div>
                  </div>
                )}
                { this.renderHighlight('End',   endTime ) }
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}